import ApiService from "./api.service";

export default {
  getFiltroCampanhas(modelo_id, opcoes = { showOverlay: true }) {
    return ApiService.get(
      "/administrativo/campanha/filtro",
      modelo_id,
      opcoes["showOverlay"]
    );
  },
  solicitarPreviaCampanha(params, opcoes = { showOverlay: true }) {
    return ApiService.post(
      "/administrativo/campanha/preview-campanha",
      params,
      null,
      opcoes["showOverlay"]
    );
  },
  buscarDadosPrevia(
    params = { sistemaLicenciadaId: null, uid: null },
    opcoes = { showOverlay: true }
  ) {
    return ApiService.get(
      "/administrativo/campanha/resposta-preview-campanha",
      `${params.sistemaLicenciadaId}/${params.uid}`,
      opcoes["showOverlay"]
    );
  }
};
